import type { ReactElement } from 'react';
import { ValuePointItem } from './value-point-item';
import { VALUE_POINTS } from './value-points';

/** 회사 소개 "What we do" — 큰 영문 제목(보조기기에는 "하는 일")과 가치 네 칸. */
export const AboutValues = (): ReactElement => (
  <section aria-labelledby="about-values-heading" className="flex flex-col gap-10 sm:gap-14">
    <header className="flex flex-col gap-4">
      <h2
        id="about-values-heading"
        className="text-[clamp(2rem,3.6vw,3.25rem)] leading-none font-bold tracking-[-0.03em]"
      >
        <span aria-hidden>What we do</span>
        <span className="sr-only">하는 일</span>
      </h2>
      <p className="text-[15px] text-muted-foreground sm:text-base">
        팀과 브랜드를 위한 굿즈를, 직접 디자인하고 확정견적으로 주문하도록 돕습니다.
      </p>
    </header>

    <ul className="grid gap-10 sm:grid-cols-2 sm:gap-x-8 xl:grid-cols-4">
      {VALUE_POINTS.map((point, index) => (
        <ValuePointItem key={point.title} point={point} order={index + 1} />
      ))}
    </ul>
  </section>
);
